export const TAP_DELAY = 250;
export const THUMBNAIL_WIDTH = 80;
export const SWIPE_THRESHOLD = 50;
export const BOTTOM_SHEET_DRAG_THRESHOLD = 20;
export const REVIEW_DETAIL_DIALOG_HEIGHT = 460;
export const LIKE_ANIMATION_DURATION = 440;
export const VIDEO_INDICATOR_ANIMATION_DURATION = 625;
